import React from 'react';
import { Helmet } from 'react-helmet';
import '../styles/Styles.css';

const Agreements = () => {
  return (
    <div className="agreement-container">
      <Helmet>
        <title>Пользовательское соглашение - ReserveCar</title>
        <meta name="description" content="Пользовательское соглашение и условия использования сайта." />
      </Helmet>

      <div className="agreement-card">
        <h1 className="agreement-title">Пользовательское Соглашение</h1>

        <div className="agreement-content">
          <p>Настоящее Пользовательское Соглашение (Далее Соглашение) регулирует отношения между ИП Михайлов (далее reservecar или Администрация) с одной стороны и пользователем сайта с другой. Сайт reservecar не является средством массовой информации.</p>

          <p>Используя сайт, Вы соглашаетесь с условиями данного соглашения. Если Вы не согласны с условиями данного соглашения, не используйте сайт reservecar!</p>

          <h2>Права и обязанности сторон</h2>
          <h3>Пользователь имеет право:</h3>
          <ul>
            <li>осуществлять поиск информации на сайте</li>
            <li>получать информацию на сайте</li>
            <li>использовать информацию сайта в личных некоммерческих целях</li>
          </ul>

          <h3>Администрация имеет право:</h3>
          <ul>
            <li>по своему усмотрению и необходимости создавать, изменять, отменять правила</li>
            <li>ограничивать доступ к любой информации на сайте</li>
            <li>создавать, изменять, удалять информацию</li>
            <li>удалять учетные записи</li>
            <li>отказывать в регистрации без объяснения причин</li>
          </ul>

          <h3>Пользователь обязуется:</h3>
          <ul>
            <li>обеспечить достоверность предоставляемой информации</li>
            <li>обеспечивать сохранность личных данных от доступа третьих лиц</li>
            <li>не копировать информацию с других источников</li>
            <li>не распространять информацию, которая направлена на пропаганду войны, разжигание национальной, расовой или религиозной ненависти и вражды</li>
            <li>не нарушать работоспособность сайта</li>
            <li>не совершать действия, направленные на введение других Пользователей в заблуждение</li>
            <li>не размещать запрещенные материалы</li>
            <li>не использовать скрипты (программы) для автоматизированного сбора информации и/или взаимодействия с Сайтом</li>
          </ul>

          <h3>Администрация обязуется:</h3>
          <ul>
            <li>поддерживать работоспособность сайта</li>
            <li>осуществлять защиту учетной записи Пользователя</li>
            <li>защищать информацию, ограниченную законами</li>
            <li>предоставлять информацию государственным органам в установленных законом случаях</li>
          </ul>

          <h2>Ответственность сторон</h2>
          <ul>
            <li>Пользователь несет полную ответственность за распространяемую информацию</li>
            <li>Администрация не несет ответственности за точность информации из сторонних источников</li>
            <li>Администрация не несёт ответственность за несовпадение ожидаемых Пользователем и реально полученных услуг</li>
            <li>Администрация не несет ответственности за услуги третьих лиц</li>
            <li>При форс-мажорных обстоятельствах Администрация не гарантирует сохранность информации</li>
          </ul>

          <h2>Условия действия Соглашения</h2>
          <p>Данное Соглашение вступает в силу при любом использовании данного сайта. Соглашение перестает действовать при появлении его новой версии. Администрация оставляет за собой право изменять данное соглашение по своему усмотрению без уведомления пользователей.</p>
        </div>
      </div>
    </div>
  );
};

export default Agreements;
